import { render, staticRenderFns } from "./PurchaseExportDetails_Details.vue?vue&type=template&id=644a04e6&"
import script from "./PurchaseExportDetails_Details.vue?vue&type=script&lang=js&"
export * from "./PurchaseExportDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports